import { AuthRoleIdEnum } from 'constants/user'

export const roleOptions = [
  {
    label: 'Organization Admin',
    value: AuthRoleIdEnum.ORG_ADMIN
  },
  {
    label: 'Admin',
    value: AuthRoleIdEnum.ADMIN
  },
  {
    label: 'Standard User',
    value: AuthRoleIdEnum.BASIC_USER
  }
]

export function getRoleName(value: number): string {
  const role = roleOptions.find(option => option.value === value)
  if (role) {
    return role.label
  }
  return 'Standard User'
}
